import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Row, Col, Button, Modal, ModalBody, Table, ModalFooter, Input } from 'reactstrap';

import { Constant } from '../../../../../../../Helpers/constant';
import { UPDATE_BOOKING } from '../../../../../../../../store/application/actionType';

const ConfirmModal = props => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [bookings, setBookings] = useState([]);
  const [modal_varying1, setmodal_varying1] = useState(true);

  useEffect(() => {
    if (props?.data !== null) {
      setBookings(
        props?.data?.map(booking => {
          return {
            ...booking,
          };
        }),
      );
    }
  }, [props]);

  /* ---------------------------- SUBMIT HANDLER ---------------------------- */
  const submitHandler = () => {
    const requestBookings = bookings?.map((booking, index) => {
      const date = props?.data[index]?.bookingDateTime?.split('T')[0];
      let time = booking?.bookingDateTime;
      time = `${time}:00.000Z`;

      return {
        objectId: booking?.bookingId,
        detailedBookingId: booking?.detailedBookingId,
        status: Constant?.BOOKING_STATUS?.CONFIRM,
        bookingDateTime: `${date}T${time}`,
        remarks: booking?.remarks,
        confirmationCode: booking?.confirmationCode,
        process: `confirm-booking`,
      };
    });

    dispatch({
      type: UPDATE_BOOKING,
      payload: {
        data: {
          projectId: Constant?.CURRENT_SELECTED_PROGRAM?.id,
          bookingTypeId: Constant?.BOOKING_TYPES?.golfBookings?.objectId,
          bookingsData: requestBookings,
        },
      },
    });
    props.onCloseHandler(false);
    setmodal_varying1(!modal_varying1);
  };

  const tog_varying1 = () => {
    props.onCloseHandler(false);
    setmodal_varying1(!modal_varying1);
  };

  const cancelHandler = () => {
    props.onCloseHandler(false);
    setmodal_varying1(!modal_varying1);
  };

  /* ---------------------------- INPUT CHANGE HANDLER ---------------------------- */
  const inputChangeHandler = (e, index) => {
    const { name, value } = e.target;

    let tempBooking = [];
    let selectedChangingBooking = null;

    switch (name) {
      case 'time_of_play':
        tempBooking = [...bookings];
        selectedChangingBooking = {
          ...tempBooking[index],
          bookingDateTime: value,
        };
        tempBooking?.splice(index, 1, selectedChangingBooking);
        // validationCheck(tempBooking)
        setBookings(tempBooking);
        break;

      case 'confirmation-number':
        tempBooking = [...bookings];
        selectedChangingBooking = {
          ...tempBooking[index],
          confirmationCode: value,
        };
        tempBooking?.splice(index, 1, selectedChangingBooking);
        // validationCheck(tempBooking)
        setBookings(tempBooking);
        break;

      case 'remarks':
        tempBooking = [...bookings];
        selectedChangingBooking = {
          ...tempBooking[index],
          remarks: value,
        };
        tempBooking?.splice(index, 1, selectedChangingBooking);
        // validationCheck(tempBooking)
        setBookings(tempBooking);
        break;

      default:
      // do nothing
    }
  };

  return (
    <Modal
      isOpen={modal_varying1}
      toggle={() => {
        tog_varying1();
      }}
      scrollable={true}
      id="exampleModal"
      size="lg"
    >
      <div className="modal-header p-3 bg-soft-secondary">
        <h5 className="modal-title" id="createboardModalLabel">
          Are you sure you want to go ahead?
        </h5>
        <Button
          type="button"
          onClick={() => {
            tog_varying1();
          }}
          id="addBoardBtn-close"
          className="btn-close btn-light"
          aria-label="Close"
        ></Button>
      </div>
      <ModalBody>
        {/* <button onClick={() => console.log({ bookings })}>get state</button> */}
        <form>
          <Row>
            <Col md={12} style={{ mixHeight: '500px' }}>
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Booking ID</th>
                    <th> Name</th>
                    <th> Confirmation No.</th>
                    <th> Confirmed Time </th>
                    <th> Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {bookings &&
                    bookings?.map((booking, index) => (
                      <tr key={index}>
                        <th>{index + 1}.</th>
                        <td>{booking?.bookingId}</td>
                        <td>{booking?.user?.name}</td>
                        <td>
                          <Input
                            type="number"
                            onWheel={e => e.target.blur()}
                            style={{ width: '140px' }}
                            className="form-control"
                            name="confirmation-number"
                            value={booking?.confirmationCode}
                            onChange={e => inputChangeHandler(e, index)}
                          />
                        </td>
                        <td>
                          <Input
                            type="time"
                            name="time_of_play"
                            className="form-control"
                            style={{ width: '140px' }}
                            value={booking?.bookingDateTime}
                            onChange={e => inputChangeHandler(e, index)}
                          />
                        </td>
                        <td>
                          <Input
                            className="form-control"
                            style={{ width: '140px' }}
                            name="remarks"
                            value={booking?.remarks}
                            onChange={e => inputChangeHandler(e, index)}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <p className="text-muted m-0">Once you will click on proceed, you will not be able to change previous state.</p>
          </Row>
        </form>
      </ModalBody>

      <ModalFooter className="pb-0">
        <div className="modal-footer mx-auto">
          <Button className="btn btn-light overlay-disable" color="primary" onClick={cancelHandler}>
            Cancel
          </Button>
          <Button className="overlay-disable" color="primary" onClick={submitHandler}>
            Sure
          </Button>
        </div>
      </ModalFooter>
      {/* <div className="modal-footer d-flex justify-content-center">
        <Button
          className="overlay-disable"
          color="primary"
          onClick={submitHandler}
          disabled={isSubmitBtnDisabled}
        >
          Submit
        </Button>
      </div> */}
    </Modal>
  );
};

export default ConfirmModal;
